/**
 * The comments a person should actually see.
 *
 * Removing a comment hides it rather than erasing it, so the entry is still
 * there in the data and every place that reads comments has to agree to skip it.
 * There are four such places — the card's count badge, the list inside an issue,
 * the activity feed, and the notifier — and the failure when one of them forgets
 * is quiet and confusing: a card advertising "3 comments" that shows two, or a
 * notification about something nobody can find.
 *
 * So the filter lives here and nothing filters for itself. If a fifth reader is
 * ever added, the thing to copy is the import.
 *
 * Generic over the shape rather than tied to Comment: the notifier works with a
 * narrower structural type of its own, so it can be tested without building
 * whole issues, and it needs this filter as much as the screens do.
 */
export function visibleComments<T extends { removed?: boolean }>(comments?: T[]): T[] {
  return (comments ?? []).filter((c) => !c.removed);
}
